import ComposicaoDividaDto from '../dto/ComposicaoDividaDto';

export default class ComposicaoDividaResource {
  codigoContrato: string;
  descricao: string;
  dataOrigem: Date;
  valorPrincipal: number;
  valorTotal: number;
  valorAcrescimos: number;
  produto: string;

  constructor(resource: ComposicaoDividaDto) {
    this.codigoContrato = resource.codigoContrato;
    this.descricao = resource.descricao;
    this.dataOrigem = new Date(resource.dataOrigem);
    this.valorPrincipal = resource.valorPrincipal;
    this.valorTotal = resource.valorTotal;
    this.valorAcrescimos = resource.valorAcrescimos;
    this.produto = resource.produto;
  }
}
